// Must stay identical to wizard/logic/manifest_names.py: the backend looks
// short names and route codes up with these same rules.

// Python's str.split() whitespace, which differs from JS \s: it has the
// separators U+001C-U+001F and U+0085, and it lacks the BOM U+FEFF.
const WHITESPACE =
  // eslint-disable-next-line no-control-regex
  /[\t-\r\x1c-\x20\x85\xa0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000]+/

export const norm = (text: string): string => {
  // NFKD does not decompose Ł, so map it first
  const folded = text
    .replace(/Ł/g, "L")
    .replace(/ł/g, "l")
    .normalize("NFKD")
    .replace(/\p{M}/gu, "")
  return folded.toUpperCase().split(WHITESPACE).filter(Boolean).join(" ")
}

export const compact = (text: string): string =>
  norm(text).replace(/[^A-Z0-9]/g, "")
